<template>
  <div></div>
</template>

<script>
/* eslint-disable */
export default {
  name: "logout",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
    localStorage.removeItem("token")
    this.$store.commit('setUser', null)
    this.$router.push("signin")
  },
};
</script>
